function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderlineBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.522,
    height: 12,
    viewBox: "0 0 12.522 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3255",
    transform: "translate(0 10.957)",
    style: {
      fill: "#231f20"
    },
    d: "M0 0h12.522v1.043H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11101",
    d: "M12.652 14.391A3.652 3.652 0 0 1 9 10.739V5h1.043v5.739a2.609 2.609 0 0 0 5.217 0V5h1.04v5.739a3.652 3.652 0 0 1-3.648 3.652z",
    transform: "translate(-6.391 -5)",
    style: {
      fill: "#231f20"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineBlack);
export default __webpack_public_path__ + "static/media/UnderlineBlack.1bb2505096e7330aaa58d565c140329a.svg";
export { ForwardRef as ReactComponent };